import {
  isEqualAllowingForFloatingPointErrors
} from "@tldraw/editor";
import { createComputedCache } from "@tldraw/store";
import { STROKE_SIZES } from "../shared/default-shape-constants.mjs";
import { getDisplayValues } from "../shared/getDisplayValues.mjs";
import { getCurvedArrowInfo } from "./curved-arrow.mjs";
import { getElbowArrowInfo } from "./elbow/getElbowArrowInfo.mjs";
import { getArrowBindings, getIsArrowStraight } from "./shared.mjs";
import { getStraightArrowInfo } from "./straight-arrow.mjs";
const arrowInfoCache = createComputedCache(
  "arrow info",
  (editor, shape) => {
    const bindings = getArrowBindings(editor, shape);
    const util = editor.getShapeUtil(shape);
    const sw = "getDisplayValues" in util.options ? getDisplayValues(util, shape).strokeWidth : editor.getCurrentTheme().strokeWidth * STROKE_SIZES[shape.props.size];
    if (shape.props.kind === "elbow") {
      const elbowInfo = getElbowArrowInfo(editor, shape, bindings, sw);
      if (!elbowInfo?.route) return getStraightArrowInfo(editor, shape, bindings, sw);
      const start = elbowInfo.swapOrder ? elbowInfo.B : elbowInfo.A;
      const end = elbowInfo.swapOrder ? elbowInfo.A : elbowInfo.B;
      return {
        type: "elbow",
        bindings,
        start: {
          handle: start.target,
          point: elbowInfo.route.points[0],
          arrowhead: shape.props.arrowheadStart
        },
        end: {
          handle: end.target,
          point: elbowInfo.route.points[elbowInfo.route.points.length - 1],
          arrowhead: shape.props.arrowheadEnd
        },
        elbow: elbowInfo,
        route: elbowInfo.route,
        isValid: true
      };
    }
    if (getIsArrowStraight(shape)) {
      return getStraightArrowInfo(editor, shape, bindings, sw);
    } else {
      return getCurvedArrowInfo(editor, shape, bindings, sw);
    }
  },
  {
    areRecordsEqual: (a, b) => a.props === b.props,
    areResultsEqual: isEqualAllowingForFloatingPointErrors
  }
);
function getArrowInfo(editor, shape) {
  const id = typeof shape === "string" ? shape : shape.id;
  return arrowInfoCache.get(editor, id);
}
export {
  getArrowInfo
};
//# sourceMappingURL=getArrowInfo.mjs.map
